import React, { useEffect, useMemo, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { isMobileAppMode, mobileNavigateBack } from "../../utils/mobileAppMode";
import { selectAdminToken } from "../../admin/sessionSlice";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const adminToken = useSelector(selectAdminToken);

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");
    const [mobileAppMode, setMobileAppMode] = useState(false);

    const { status, user, error } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 
    // Match Sort & Toss: treat as mobile-app mode if it appears in URL, user payload, or persisted userData.
    const isFromMobileApp = useMemo(() => {
      const fromMobileAppInUrl =
        String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() === "true";
      const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
      const persistedFromMobileApp = (() => {
        try {
          const persisted = JSON.parse(window.sessionStorage.getItem("userData") || "{}");
          return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
        } catch {
          return false;
        }
      })();
      // Keep compatibility with our earlier global flag as well.
      return fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp || isMobileAppMode();
    }, [location.search, user?.fromMobileApp]);

    const themeLogoUrl = useMemo(() => {
      const raw = themeData?.logo;
      if (raw == null || String(raw).trim() === "") return "";
      // Match Sort & Toss style: build from env base + relative key.
      // Arrow Up stores companyLogoUrl already expanded via REACT_APP_S3BUCKET_URL in loginSlice.
      // For theme logo, prefer REACT_APP_S3BUCKET_URL if present; fall back to REACT_APP_S3_PATH.
      const baseRaw = process.env.REACT_APP_S3BUCKET_URL || process.env.REACT_APP_S3_PATH || "";
      const base = String(baseRaw).replace(/\/+$/, "");
      const rel = String(raw).replace(/^\/+/, "");
      return base ? `${base}/${rel}` : rel;
    }, [themeData?.logo]);

    const displayLogoUrl = logoUrl || themeLogoUrl;


  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname) && adminToken) {
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch, location.pathname, adminToken]);

  useEffect(()=>{
    console.log(backButtonUrl);
    console.log(companyLogoUrl);
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])

  useEffect(() => {
    try {
      setMobileAppMode(isFromMobileApp);
    } catch {
      setMobileAppMode(false);
    }
  }, [location.pathname, isFromMobileApp]);

  const onMobileNavigateBack = (e) => {
    e?.preventDefault?.();
    mobileNavigateBack();
  };

  const onWebNavigateBack = (e) => {
    e?.preventDefault?.();
    const target = String(backUrl || "").trim();
    if (!target) return;
    // If stored url is absolute, use hard navigation.
    if (/^https?:\/\//i.test(target)) {
      window.location.href = target;
      return;
    }
    // Otherwise, navigate within SPA to avoid blank screen / state loss.
    navigate(target);
  };


  useEffect(() => {
    if (themeStatus === 'succeeded' && themeData) {
      applyCustomTheme(themeData.colors);
      const body = document.body;
      const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${process.env.REACT_APP_S3_PATH + bg})`;
      }
    }
  }, [themeStatus, themeData]);

  // Browser tab title follows whatever hunt is currently loaded, everywhere in the player app.
  useEffect(() => {
    const name = String(themeData?.huntName || "").trim();
    document.title = name || "ExtraMile Play";
  }, [themeData?.huntName]);


  return (
    <>
      <header className="upperaction">
        <a
          href={process.env.REACT_APP_BASE_URL}
          className="logo-link"
          aria-label="Home"
          onClick={isFromMobileApp ? onMobileNavigateBack : undefined}
        >
          {displayLogoUrl ? <img src={displayLogoUrl} className="logo-holder" alt="" /> : null}
        </a>
        {!isFromMobileApp && backUrl ? (
          <div className="back-holder">
            <button type="button" className="back-default" onClick={onWebNavigateBack}>
              Back
            </button>
          </div>
        ) : null}
       
      </header>
      {children}
    </>
  );
}

export default USER;
